import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LocaleDto } from '@dto';
import { RequestMethodEnum, RequestOptions } from '@models';
import { GenericService } from './generic.service';

const LOCALES_ENDPOINT = 'api/v1/reference/locales';

@Injectable({ providedIn: 'root' })
export class LocalesService {
  private _locales: LocaleDto[] | undefined;
  get locales(): LocaleDto[] | undefined {
    return this._locales;
  }

  constructor(private genericService: GenericService) {}

  locales$(): Observable<LocaleDto[]> {
    const options: RequestOptions<undefined, LocaleDto[]> = {
      method: RequestMethodEnum.GET,
      path: LOCALES_ENDPOINT,
    };
    return this.genericService.request(options).pipe(tap(locales => (this._locales = locales)));
  }
}
